import React from 'react';
import { ProductTableProps, Product } from '../../../types';
import { TableRow, TableHeader, Badge } from '../atoms';
import Icon from '../../atoms/Icon';
import './ProductTable.css';

const ProductTable: React.FC<ProductTableProps> = ({
  products,
  onEdit,
  onDelete,
  onDuplicate,
  loading = false
}) => {
  const headers = ['Name', 'Collection', 'Flavors', 'Sizes', 'Fillings', 'Cover Icing', 'Status', 'Actions'];

  const renderProductRow = (product: Product) => {
    return (
      <TableRow 
        key={product.id} 
        className="product-row clickable-row"
        onClick={() => onEdit(product)}
      >
        <div className="product-name">
          <span>{product.name}</span>
        </div>
        <div className="product-collection">{product.collection}</div>
        <div className="product-flavors">
          {product.flavors.filter(f => f.available).length} flavors
        </div>
        <div className="product-sizes">
          {product.sizes.length} sizes
        </div>
        <div className="product-fillings">
          {product.fillings ? product.fillings.length : 0} fillings
        </div>
        <div className="product-cover-icing">
          {product.coverIcingOptions ? product.coverIcingOptions.length : 0} options
        </div>
        <div className="product-status">
          <Badge 
            text={product.isActive ? 'Active' : 'Inactive'} 
            variant={product.isActive ? 'success' : 'danger'} 
          />
        </div>
        <div className="product-actions">
          <button 
            className="action-button edit-button" 
            onClick={(e) => {
              e.stopPropagation();
              onEdit(product);
            }}
            aria-label="Edit product"
          >
            <Icon type="edit" size="small" />
          </button>
          <button 
            className="action-button duplicate-button" 
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate(product);
            }}
            aria-label="Duplicate product"
          >
            <Icon type="copy" size="small" />
          </button>
          <button 
            className="action-button product-delete-button" 
            onClick={(e) => {
              e.stopPropagation();
              onDelete(product);
            }}
            aria-label="Delete product"
          >
            <Icon type="delete" size="small" />
          </button>
        </div>
      </TableRow>
    );
  };

  return (
    <div className="product-table">
      <TableHeader headers={headers} />
      <div className="product-table-body">
        {loading ? (
          <div className="product-table-loading">Loading products...</div>
        ) : products.length === 0 ? (
          <div className="product-table-empty">No products found</div>
        ) : (
          products.map(renderProductRow)
        )}
      </div>
    </div>
  );
};

export default ProductTable;
